module.exports = __webpack_public_path__ + "static/lowerright_box-9cdbfb8b6e50cc07744f1fc57c6bd618.png";